const cyDirective = {
    mounted(el, binding) {
        el.dataset.cy = binding.value;
    },
};

export default cyDirective;
